module.exports = __webpack_public_path__ + "static/img/suggestions-empty.039c062.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/empty/suggestions-empty.png
// module id = wopq
// module chunks = 1